import React from 'react';
import './describesection.scss';
import { FiArrowRight } from 'react-icons/fi';
const DescribeSection = () => {
  return (
    <div className="describe">
      <h1>Compare places using Google Maps</h1>
      <h2>
        With the help of Google Maps, compare upto 4 places based on their rating and reviews.
      </h2>
      <p>
        <a href="#sample"><FiArrowRight /> Sample comparison</a>
        <a href="#questions"><FiArrowRight /> I have questions</a>
      </p>
    </div>
  )
}

export default DescribeSection;